import { Controller } from "stimulus"
import { debounce } from "../utils"

function validTarget(el) {
  return el.form && !el.form.hasAttribute("aria-busy")
}

export default class extends Controller {
  validate = debounce(({ target, params }) => {
    if (validTarget(target)) {
      const submitter = this.#createSubmitter(params.action)
      target.form.append(submitter)
      target.form.requestSubmit(submitter)
    }
  }, 350)

  #createSubmitter(action) {
    if (!action) { return null }

    const submitter = document.createElement('input')
    submitter.type = 'submit'
    submitter.style.display = 'none'
    submitter.setAttribute('formaction', action)

    return submitter
  }
}
